// The 12 model visemes a custom puppet SVG must provide, by element id. The
// #mouth group is required too; #blink (eyelids) and viseme-grin (resting mouth)
// are optional — the puppet just won't blink / falls back to viseme-closed.
export const REQUIRED_VISEMES = [
	'viseme-closed', 'viseme-ah', 'viseme-d', 'viseme-e', 'viseme-f', 'viseme-l',
	'viseme-m', 'viseme-oh', 'viseme-r', 'viseme-s', 'viseme-uh', 'viseme-oo',
];

// Mirrors the server default (config.files.maxPuppetSvgBytes). Used for the
// client-side size check + the UI hint; the server is the real enforcement.
export const MAX_PUPPET_SVG_BYTES = 10 * 1024 * 1024;

// Validate a custom puppet SVG (browser DOMParser). Returns
// { ok, missing: string[], error: string|null }. Uses querySelector (not
// getElementById, which is unreliable on XML-parsed SVG documents).
export function validatePuppetSvg(svgText) {
	if(!svgText || !/<svg[\s>]/i.test(svgText)) return { ok: false, missing: [], error: 'That doesn\'t look like an SVG file.' };
	if(/<script[\s>]/i.test(svgText)) return { ok: false, missing: [], error: 'For safety, the SVG must not contain <script> elements.' };

	let doc;
	try { doc = new DOMParser().parseFromString(svgText, 'image/svg+xml'); }
	catch(e) { return { ok: false, missing: [], error: 'Could not parse the SVG.' }; }
	if(doc.querySelector('parsererror') || !doc.querySelector('svg')) {
		return { ok: false, missing: [], error: 'Invalid SVG markup.' };
	}
	if(!doc.querySelector('#mouth')) {
		return { ok: false, missing: [], error: 'The SVG needs a group with id="mouth" holding the viseme shapes.' };
	}
	const missing = REQUIRED_VISEMES.filter(id => !doc.querySelector(`#${id}`));
	if(missing.length) return { ok: false, missing, error: `The SVG is missing these viseme shapes: ${missing.join(', ')}` };
	return { ok: true, missing: [], error: null };
}
